
  
async function loadProducts(wishtab_prd_list) {
  try {
    

    const productPromises = wishtab_prd_list.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to fetch product: ${handle}`);
          }
          return response.json();
        })
        .catch(error => {
          console.error('Error fetching product:', handle, error);
          return null; // return null or {} to keep Promise.all from failing
        })
    );
    
    const products = await Promise.all(productPromises);
    const productItem = document.getElementById('wishtab-product-template');
    const groupedProducts = new Map();
    
    products.forEach(product => {
      if (product) {
        const productData = product;
        const { type: productType } = productData;

        if (!groupedProducts.has(productType)) {
          groupedProducts.set(productType, []);
        }
        groupedProducts.get(productType).push(product);
      }
    });

    const tabsContainer = document.querySelector('.wishtab_header');
    const tabsContentContainer = document.querySelector('.wishtab_body');

    groupedProducts.forEach((products, productType) => {
      const wishlistTab = createWishlistTab(productType);
      tabsContainer.appendChild(wishlistTab);

      const tabContent = document.createElement('div');
      tabContent.classList.add('wishtab_item_data');
      tabContent.id = `content-${productType}`;
      tabsContentContainer.appendChild(tabContent);

      products.forEach(product => {
        const clonePrdItem = document.importNode(productItem.content, true);
        const  productData = product;
        const productVariant = productData?.variants[0];

        displayProductDetails(clonePrdItem, productData, productVariant);
        tabContent.appendChild(clonePrdItem);
      });
    });
    initializeTabs();
    
    checkDemandProducts()
    document.querySelector('.lodaing_cards').style.display='none';
  } catch (error) {
    console.error('Error in processing product data:', error);
  }
}

function createWishlistTab(productType) {
  const wishlistTab = document.createElement('div');
  wishlistTab.classList.add('wishlist_item');
  wishlistTab.dataset.tab = productType;
  wishlistTab.textContent = productType;

  const wishTabBar = document.createElement('div');
  wishTabBar.classList.add('wishTabBar');
  
  wishlistTab.appendChild(wishTabBar);
  return wishlistTab;
}

function displayProductDetails(clonePrdItem, productData, productVariant) {
  
  const prdMedia = clonePrdItem.querySelector('.wishtab_prd_media');
  prdMedia.href = productData.url;

  const titleElement = clonePrdItem.querySelector('.wishtab_card_heading');
  const titleText = productData.title;

  const titleWords = titleText.split(' ');

  if (titleWords.length > 3) {
    titleElement.textContent = titleWords.slice(0, 3).join(' ') + '...';
  } else {
    titleElement.textContent = titleText;
  }


  titleElement.href = productData.url;
  
  const imageElement = clonePrdItem.querySelector('.product-image');
  imageElement.src = productData?.featured_image ? `${productData.featured_image}&width=400`: 'https://cdn.shopify.com/s/files/1/0586/7883/7309/files/product-placeholder.png?v=1704436166&width=400'; 
  imageElement.alt = productData.title;
  
  const prdQty = clonePrdItem.querySelector('.wishtab_prd_qty');
  prdQty.textContent = productData.options[0].values[0];

  const prdType = clonePrdItem.querySelector('.wishtab_prd_type');
  prdType.textContent = productData.type;

  const priceElement = clonePrdItem.querySelector('.wishtab_product_price');
  priceElement.innerHTML = productData.available ? `₹ ${productVariant?.price / 100}` : `<span class="sold_wish_prd">Out of Stock</span>`;

  const ATCBtnElement = clonePrdItem.querySelector('.wishItemAdd'); 
  ATCBtnElement.innerHTML = productData.available ? `<span>Add</span>` : `<span>Notify Me</span>`;
  if (!productData.available) {
    ATCBtnElement.classList.add('wishItemSoldOut');
    ATCBtnElement.setAttribute('onclick', 'addProductToDemandList(this)');
  }
  
  const productItem = clonePrdItem.querySelector('.wishtab_product_item');
  productItem.dataset.wishtabProductId = productData.id;
  clonePrdItem.querySelector('.wishtab_btn_style').dataset.variantId = productVariant.id; 
  clonePrdItem.querySelector('.wishtab_btn_style').dataset.productId = productData.id; 
  clonePrdItem.querySelector('.wishtab_btn_style').dataset.productHandle = productData.handle; 
  clonePrdItem.querySelector('.reorder_love').dataset.productHandle = productData.handle;
  clonePrdItem.querySelector('.wishItemDelete').dataset.productHandle = productData.handle;
}

function initializeTabs() {
  const switchTab = (tabName) => {
    document.querySelectorAll('.wishlist_item').forEach((tab) => {
      tab.classList.remove('active');
    });
    document.querySelectorAll('.wishtab_item_data').forEach((content) => {
      content.classList.remove('active');
    });

    const activeTab = document.querySelector(`.wishlist_item[data-tab="${tabName}"]`);
    activeTab.classList.add('active');

    const activeContent = document.getElementById(`content-${tabName}`);
    activeContent.classList.add('active');
  };

  const firstTab = document.querySelector('.wishlist_item');
  if (firstTab) {
    switchTab(firstTab.dataset.tab);
  }

  document.querySelectorAll('.wishlist_item').forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabName = tab.dataset.tab;
      switchTab(tabName);
    });
  });
}

const customerIdWishlist = document.getElementById('customer-data-wishlist-page')?.value
	if (customerIdWishlist){
	
		fetch(`https://nodejs.animeal.in/api/get-wishlist?customer_id=${customerIdWishlist}`)
		.then(response => response.json()) // Parse the response as JSON
		.then(data => {
			if (data.success) {
				
				if(data?.wishlist?.length > 0){
					// document.querySelector('.reorder_main_wrapper').style.display = 'block';
					loadProducts(data.wishlist)
				} else {
        emptyWishlistHandler()
			}
    }
		})
		.catch(error => {
			emptyWishlistHandler()
		});
  }

// loadProducts();


async function removeWishlistProduct(event, customerId) {
  try {
    // Get the product handle from the button's data attribute
    const productHandle = event.getAttribute('data-product-handle');
    
    if (!productHandle) {
      console.error('Product handle is missing.');
      return;
    }

    // Prepare the payload for the API request
    const requestBody = {
      customer_id: customerId,
      product_id: productHandle,
      // type: 'update-wishlist',
    };

    // Perform the API call using fetch
    const response = await fetch('https://nodejs.animeal.in/api/update-wishlist', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    // Check if the response is successful
    const data = await response.json();
    
    if (response.ok && data.success) {

      // Handle the visual changes to the heart icon and remove the product item if needed
      const svgPath = event.closest('.wishtab_product_item').querySelector('svg path');
      
      if (data.wishlist.includes(productHandle)) {
        // Product is still in the wishlist
        svgPath.setAttribute('stroke', 'red');
        svgPath.setAttribute('fill', 'red');
      } else {
        const wishtab_header = document.querySelector('.wishtab_header');
        wishtab_header.innerHTML = '';
        const wishtab_body = document.querySelector('.wishtab_body');
        wishtab_body.innerHTML = '';
        document.querySelector('.lodaing_cards').style.display = 'block'
        loadProducts(data.wishlist)
      }
    } else {
      console.error('Error updating wishlist:', data.message || 'Unknown error');
    }
  } catch (error) {
    console.error('Error during API request:', error); // Handle network or other errors
  }
}

function emptyWishlistHandler(){
  
  document.querySelector('.lodaing_cards').style.display='none';
  document.querySelector('.empty-wishlist-container').style.display = 'flex';
}


async function addProductToDemandList(elm) {
  try {
      const customerId = document.getElementById('customer-data-wishlist-page')?.value;
      const productId = elm.getAttribute('data-product-id');
      const productHandle = elm.getAttribute('data-product-handle');

      const requestData = {
          customer_id: customerId,
          product_id: productId,
          product_handle: productHandle,
          // type: 'update-demand-product'
      };

      if (!customerId || !productId || !productHandle) {
          throw new Error('Missing required data fields (customer_id, product_id, product_handle)');
      }

      const response = await fetch('https://nodejs.animeal.in/api/update-demand-product', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
      });

      if (!response.ok) {
          throw new Error(`Request failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && !data.removed) {
        elm.querySelector('span').textContent = 'Notified!';
        elm.querySelector('span').setAttribute('title', 'If the product becomes available, we will notify you via email.');
        elm.classList.add('notified');
      }
      
      else if (data.success && data.removed) {
        elm.querySelector('span').textContent = 'Notify Me';
        elm.classList.remove('notified');
      }

  } catch (error) {
      console.error('Error:', error);
  }
}


async function checkDemandProducts() {
  try {
    const response = await fetch('https://nodejs.animeal.in/api/check-demand-product', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      const allOutofstocs = document.querySelectorAll('.atc-wishlist-prd.wishItemSoldOut');
      allOutofstocs.forEach(outofstock => {
        const customerId = document.getElementById('customer-data-wishlist-page')?.value;
        const productId = outofstock.getAttribute('data-product-id');
        
        const customerData = { customer_id: customerId, product_id: productId };

        const isNotified = data.allRecords.some(record => 
          record.customer_id === customerData.customer_id && record.product_id === customerData.product_id
        );

        if (isNotified) {
          const spanElement = outofstock.querySelector('span');
          spanElement.textContent = 'Notified!';
          spanElement.setAttribute('title', 'If the product becomes available, we will notify you via email.'); // Hover message
          outofstock.classList.add('notified');
        }
      });
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

